/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoSendResetPasswordTokenInput = {
    clientMutationId?: string | null;
    usernameEmail: string;
};
export type ForgetPasswordFormMutationVariables = {
    input: infoSendResetPasswordTokenInput;
};
export type ForgetPasswordFormMutationResponse = {
    readonly infoSendResetPasswordToken: {
        readonly clientMutationId: string | null;
    } | null;
};
export type ForgetPasswordFormMutation = {
    readonly response: ForgetPasswordFormMutationResponse;
    readonly variables: ForgetPasswordFormMutationVariables;
};



/*
mutation ForgetPasswordFormMutation(
  $input: infoSendResetPasswordTokenInput!
) {
  infoSendResetPasswordToken(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoSendResetPasswordTokenPayload",
    "kind": "LinkedField",
    "name": "infoSendResetPasswordToken",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ForgetPasswordFormMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ForgetPasswordFormMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "57b16ba6a6d1c3be28a1440778186917",
    "id": null,
    "metadata": {},
    "name": "ForgetPasswordFormMutation",
    "operationKind": "mutation",
    "text": "mutation ForgetPasswordFormMutation(\n  $input: infoSendResetPasswordTokenInput!\n) {\n  infoSendResetPasswordToken(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = '4501e75595c648cac85d40dd3e9e5c2a';
export default node;
